const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20man%20in%20his%2030s%2C%20warm%20lighting%2C%20clean%20neutral%20background%2C%20friendly%20expression%2C%20editorial%20portrait%20style%2C%20soft%20natural%20look&width=160&height=160&seq=avatar-c1&orientation=squarish',
    name: '王先生',
    role: '资深媒体从业者',
    text: '51爆料网的更新速度和内容质量都让人惊喜，很多行业内幕都是在这里第一时间看到的，已经成为我每天必刷的平台。',
    time: '2小时前',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20woman%20in%20her%2020s%2C%20warm%20lighting%2C%20clean%20minimal%20background%2C%20confident%20expression%2C%20editorial%20portrait%20photography%2C%20soft%20natural%20look&width=160&height=160&seq=avatar-c2&orientation=squarish',
    name: '李女士',
    role: '互联网从业者',
    text: '信息量很大而且分类清晰，热门爆料、深度揭秘都有专门的板块，找起来特别方便。实名审核也让人比较放心。',
    time: '5小时前',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20man%20in%20his%2040s%2C%20warm%20ambient%20lighting%2C%20clean%20studio%20background%2C%20thoughtful%20expression%2C%20editorial%20portrait%20style%2C%20soft%20natural%20look&width=160&height=160&seq=avatar-c3&orientation=squarish',
    name: '张先生',
    role: '金融分析师',
    text: '作为金融从业者，51爆料网上的行业动态爆料给了我很多一手参考。平台的内容审核机制也很到位，不会看到虚假信息。',
    time: '8小时前',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20woman%20in%20her%2030s%2C%20warm%20soft%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20smile%2C%20editorial%20portrait%20photography%2C%20natural%20look&width=160&height=160&seq=avatar-c4&orientation=squarish',
    name: '陈女士',
    role: '自媒体博主',
    text: '用来追踪热点话题太方便了，每天看看热度榜单就知道今天大家都在关注什么，是我选题的重要参考来源。',
    time: '12小时前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-label font-semibold text-accent-600 uppercase tracking-wider">
            读者评价
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2 mb-3">
            读者怎么说
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            来自51爆料网真实读者的使用反馈与评价
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {comments.map((c) => (
            <div
              key={c.name}
              className="flex flex-col p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-11 h-11 rounded-full object-cover shrink-0"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.role}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                &ldquo;{c.text}&rdquo;
              </p>
              <div className="mt-4 pt-3 border-t border-background-200/60 flex items-center justify-between">
                <div className="flex text-accent-500 text-sm">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <span className="text-xs text-foreground-400">{c.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}